import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/brandonwu/Documents/PTS/Gatsby/Instana-1-Day-Partner-Workshop/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const Title = () => <span>
    Lab 9 - Custom Events <br />
  </span>;
;
export const _frontmatter = {};
const layoutProps = {
  Title,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Lab Overview`}</h2>
    <p>{`In this lab you will create a custom event. We will be creating an issue type event, which triggers when something out of the ordinary occurs. In this case, it triggers when a component of our application is offline. At the end of this lab, you will be able to verify that your event has triggered and review the event.`}</p>
    <h2>{`Step 1:`}</h2>
    <p>{`Click Settings. `}</p>
    <p>{`Then click Events. `}</p>
    <p>{`Lastly, click New Events. `}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "63.541666666666664%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAACRElEQVQ4y52TS2sUQRSFWxFduBQ3QiBqEBVF3Pv/NKi4EkFIohuZCAETE9E/EDSIwVcgmxDN6MTYM11d7/eRW51JoksvHKopuk5/p+7t6sTk1TTbW8BwxPL2zg+wVsCHCOfDf6k6PnE5zc4vQCuTB7t7YFwgpYwQIkJMiDGVD4yfQ4zwIfyjeKDq1IVraf7lKwDITEjEGMGFgrUO2li0XMA6ejYQstvPANJRpYSUcwGpTk/dSM8WlyGB3G8YjLXFwHlfzImIikistfC07x2S0cjGIFrbvRdCWQthb2mlECql4ZzHuJqmwWB3Fzv9fjEbl9/axLeNT/j+9SPk5/ewPhRDAqlOnj80ZC0vB3PO5aAQEnt7v6GURCLS/f0sGMygD/1zB7H+BWMdpFKIKY0JuzvkQpSoZEhncwqQWoPbAGEDuPFFwkVkHBZdg9Jduqo6O5l6ix0h56IjODB0EEqCKQdpfZGwHsp290vU1BBjLCgdNfAvQqktXIwHXQzBouEcNddgyhYNhQHXrowVzR2NilQaw6YtM1wdOzeVei+WgRgyq2vAu84uJ6TowJVEo1yJ2moHQatxYGQaU0lDd0iEXEhUly5eSfPTt7E8M5dnpu/jyd0HeHznHpYePgLaGtyYQkZRyUzsR3chlibQ/I0jF8Nb12+mN0/nsLW+nr+srmJzbQ0bb99he/0DIhcYNQK10Gj2I5MaaQ9/txLZYDSOXJ2ZSM9XXnfToA2OVkq+RK6lxUh1GpJZiCUqNYRWrcmQoWEt/gAi5sCArDhhmAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Lab 9",
        "title": "Lab 9",
        "src": "/Instana-1-Day-Partner-Workshop/static/321f22a88928040cd091d2142e787f54/3cbba/lab9.1.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/321f22a88928040cd091d2142e787f54/7fc1e/lab9.1.png 288w", "/Instana-1-Day-Partner-Workshop/static/321f22a88928040cd091d2142e787f54/a5df1/lab9.1.png 576w", "/Instana-1-Day-Partner-Workshop/static/321f22a88928040cd091d2142e787f54/3cbba/lab9.1.png 1152w", "/Instana-1-Day-Partner-Workshop/static/321f22a88928040cd091d2142e787f54/0b124/lab9.1.png 1728w", "/Instana-1-Day-Partner-Workshop/static/321f22a88928040cd091d2142e787f54/9d3b4/lab9.1.png 1770w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <h2>{`Step 2:`}</h2>
    <p>{`Configure your Event with the following name: `}</p>
    <pre><code parentName="pre" {...{}}>{`MySQL is Offline -<your last name> 
`}</code></pre>
    <p>{`Enter Description of the Event to:  `}</p>
    <pre><code parentName="pre" {...{}}>{`MySQL has been offline for 1 minute  
`}</code></pre>
    <h2>{`Step 3:`}</h2>
    <p>{`Configure the settings the following way: `}</p>
    <p>{`Set the Issue Severity to Critical. `}</p>
    <p>{`Set the Grace Period to 5s. `}</p>
    <p>{`Set Condition Source to System Rules. `}</p>
    <p>{`For System Rules, select: Hosts that do not have matching entities on them. `}</p>
    <p>{`For Entity Type drop down, select MySQL DB. `}</p>
    <p>{`Change the Entity Label Operator to Contains. `}</p>
    <p>{`Enter MySQL in the Entity Label field. `}</p>
    <p>{`Select 1 min in the Offline for drop down. `}</p>
    <p>{`Select your Application Perspective for the Scope. `}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.72222222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABcElEQVQoz5VTy07DMBDMx/ABSBUSQgIkxDdygCMHxB+BQko5t8VJEzt+rQftJk7bQA+sNFrH9o7Hs06htIZxHkQJkQhENGVK6RhE4FhvNqiqCqvVFz5XK3wsl6ibRtYKpWq0bYfeOjjvYZ2Hcx7eh4k8w4cgRQ+PT1hcXuHm7h4X17c4O1/g+eV1IOyMgdZGCEOIiJELo4xDHMBzMg5RlK63W7yVJcpqibKq8F6WYGEDYadFUUaz62CdE5IEiLLeWvlmW/gWpyKlhKLjzUTywYijT4ebhGxcp+zvDLwmCttOT4SsYAAd+Zfn4q/5Y48ZRdPsYIwZ0PdiPHvImZXFeOjlMbLP8cDnQmuNwCQ+jGQB2Vc5lTeGiHqnoW2EcQRjCT3nvp+atie0dro/p+zlHHs7Row1Q+G+ttgqhbZtpXt8wl++zBuVg8Ym5ocvhEop1HWNb6XgxydxSuUcLkTYECSzVWxNwX/J/srpX5hHiAk/YeykgB2zBwMAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Lab 9",
        "title": "Lab 9",
        "src": "/Instana-1-Day-Partner-Workshop/static/f75f2c1acf061c1f5ccd993a4aea628f/3cbba/9.2.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/f75f2c1acf061c1f5ccd993a4aea628f/7fc1e/9.2.png 288w", "/Instana-1-Day-Partner-Workshop/static/f75f2c1acf061c1f5ccd993a4aea628f/a5df1/9.2.png 576w", "/Instana-1-Day-Partner-Workshop/static/f75f2c1acf061c1f5ccd993a4aea628f/3cbba/9.2.png 1152w", "/Instana-1-Day-Partner-Workshop/static/f75f2c1acf061c1f5ccd993a4aea628f/0b124/9.2.png 1728w", "/Instana-1-Day-Partner-Workshop/static/f75f2c1acf061c1f5ccd993a4aea628f/6358c/9.2.png 1876w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Step 4: `}</p>
    <p>{`Stop the MySQL Container on your host. `}</p>
    <p>{`SSH into your host. `}</p>
    <p>{`Execute the following command: `}</p>
    <pre><code parentName="pre" {...{}}>{`sudo docker stop robot-shop_mysql_1 
`}</code></pre>
    <h2>{`Step 5:`}</h2>
    <p>{`Verify that your Event has triggered. `}</p>
    <p>{`Select Issues. `}</p>
    <p>{`Review Event. `}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "45.833333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABRklEQVQoz61SbUrFMBDs/Y/gbbyBoqgoqCCI2PfS9CPJfiUjm1dURPxlYEgzSSY7Ox2OIdq8bFCRJqIQtU+w6J8oxIjzghBnEDOSEIbMavkwIt9ctjIFiFXkQv2wqELVfoXveQHMgpxLvyOmGJaU7Pj2hvTy3DglsCqIuL/oVchf0C+4sHNDWjebo1emDf8wBlOzZgYTadUMHbWi2o6f331t3/YUFUBdH1GfzjBkYiP3z9LYbRKDS9lBfZZ9pnzihejrTM6nkMZXlMtzDDwFo3BACYfG4QhZZqidUvY+EsveT9l5xbJunfc19d4JyINyy3pzYfJ4j+X2qm131+CHW1QRWK1Y1w1byli3hEKEWltP2AWdM6v9MQ/DzPzXw6CcjXLC+D62w/uIGGMX88tTnLugD++X815VmCKOYeqC2W2zoLbWXX0AMka+AH613GsAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Lab 9",
        "title": "Lab 9",
        "src": "/Instana-1-Day-Partner-Workshop/static/56f5647c93f78144ca3cc79eab0f6648/3cbba/lab9.3.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/56f5647c93f78144ca3cc79eab0f6648/7fc1e/lab9.3.png 288w", "/Instana-1-Day-Partner-Workshop/static/56f5647c93f78144ca3cc79eab0f6648/a5df1/lab9.3.png 576w", "/Instana-1-Day-Partner-Workshop/static/56f5647c93f78144ca3cc79eab0f6648/3cbba/lab9.3.png 1152w", "/Instana-1-Day-Partner-Workshop/static/56f5647c93f78144ca3cc79eab0f6648/0b124/lab9.3.png 1728w", "/Instana-1-Day-Partner-Workshop/static/56f5647c93f78144ca3cc79eab0f6648/f0200/lab9.3.png 2146w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      